import Vue from 'vue';
import { MutationTree } from 'vuex';
import {
  IState,
  SetTokenPayload,
  ContentChangePayload,
  SetCompressPayload,
  SetFilePayload
} from './types';
import { Type, File } from '@/sandbox/types';
import { formatPathByFilename } from '@/sandbox/utils';

const mutations: MutationTree<IState> = {
  setLimitState(state, payload) {
    state.limitState = payload;
  },
  setRootPath(state, path: string) {
    state.rootPath = path;
  },
  setResetPath(state, path: string) {
    state.resetPath = path;
  },
  setToken(state, payload: SetTokenPayload) {
    state.token = payload.token;
  },
  setContentChange(state, payload: ContentChangePayload) {
    const { path, content } = payload;
    const { type, files } = state;
    const index = files.findIndex((file) => file.path === path);
    Vue.set(state.files, index, {
      ...files[index],
      content,
      isDirty: true
    });
  },
  setCompress(state, compress: SetCompressPayload) {
    state.compress = {
      url: compress.url,
      files: compress.files.map((p) => formatPathByFilename(p, state.rootPath))
    };
  },
  setFiles(state, { files }: SetFilePayload) {
    state.files = files;
  },
  setFile(state, { file, index }: { file: File; index?: number }) {
    const files = state.files;
    if (index !== undefined) {
      Vue.set(files, index, { ...files[index], ...file });
      return;
    }
    if (index === -1) {
      files.push(file);
      return;
    }
    const has = files.some((item, index) => {
      if (item.path === file.path) {
        Vue.set(files, index, { ...item, ...file });
        return true;
      }
      return false;
    });
    if (!has) {
      files.push(file);
    }
  },
  setType(state, type: Type) {
    state.type = type;
  },
  setTrees(state, tree: File) {
    state.tree = tree;
  },
  setSandboxConfig(state, config) {
    state.sandboxConfig = config;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setIsRecycled(state, isRecycled) {
    state.isRecycled = isRecycled;
  }
};

export default mutations;
